export interface WebsiteConfig {
  title: string;
  description: string;
  coverImage?: string;
  logo: string;
  /**
   * Specifying a valid BCP 47 language helps screen readers announce text properly.
   * See: https://dequeuniversity.com/rules/axe/2.2/valid-lang
   */
  lang: string;
  /**
   * blog full path, no ending slash!
   */
  siteUrl: string;
  /**
   * full url, no username
   */
  facebook?: string;
  /**
   * full url, no username
   */
  twitter?: string;
  /**
   * hide or show all email subscribe boxes
   */
  showSubscribe: boolean;
  /**
   * create a list on mailchimp and then create an embeddable signup form. this is the form action
   */
  mailchimpAction?: string;
  /**
   * this is the hidden input field name
   */
  mailchimpName?: string;
  /**
   * name and id of the mailchimp email field
   */
  mailchimpEmailFieldName?: string;
  /**
  /**
   * Meta tag for Google Webmaster Tools
   */
  googleSiteVerification?: string;
  /**
  /**
   * Appears alongside the footer, after the credits
   */
  footer?: string;
}

const config: WebsiteConfig = {
  title: 'StudyCo',
  description: 'StudyCoは、アプリケーションの設計・実装から、統計・機械学習、ブロックチェーン、量子コンピュータなど、ITを中心に幅広く調査・実践している少数精鋭のクローズドなコミュニティです。 ',
  coverImage: 'img/blog-cover.png',
  logo: 'avatars/icon.png',
  lang: 'ja',
  siteUrl: 'https://www.studyco.io',
  facebook: undefined,
  twitter: undefined,
  showSubscribe: false,
  mailchimpAction: undefined,
  mailchimpName: undefined,
  mailchimpEmailFieldName: undefined,
  googleSiteVerification: undefined,
  footer: '',
};

export default config;
